<template>
  <Adminlte>
    <div class="box box-primary center-block">
      <div class="box-header with-border">
        <i class="fa fa-bar-chart font-dark"></i><h3 class="box-title">Relatórios - Questionários</h3>
      </div>
      <section v-if="!isRenderingReports" class="content">
        <button @click="renderReports()" type="button" class="btn btn-primary top-btn">Gerar</button>
        <div class="row main-row">
          <div class="col-xs-12 col-md-9">
            <div class="report-row">
              <h4>
                Eixo do Questionário
                <button @click="selectAll(axes)" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
                <button @click="clearSelected(axes)" type="button" class="btn btn-default btn-xs">Limpar</button>
              </h4>
              <div class="axes-container">
                <span v-for="axis in axes" @click="axis.isSelected = !axis.isSelected" :class="{ highlight: axis.isSelected }">
                  {{ axis.description }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="report-row">
                <p><strong>Ano</strong></p>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="year" class="form-control">
                      <option v-for="year in getAvailableYears" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="row main-row">
          <div class="col-xs-12 col-md-4">
            <div class="report-row" v-if="(availableReports.length > 0 || respondents.length > 0) && userCanSelectRespondents">
              <h4>
                Respondentes
                <button @click="selectAll(respondents)" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
                <button @click="clearSelected(respondents)" type="button" class="btn btn-default btn-xs">Limpar</button>
              </h4>
              <div v-for="park in respondents" :key="park.id" class="checkbox">
                <label>
                  <input v-model="park.isSelected" type="checkbox"> {{ park.name }}
                </label>
              </div>
            </div>
            <!-- OR -->
            <div class="report-row" v-if="(availableReports.length > 0 || respondents.length > 0) && userHasParkRole">
              <h4>
                Respondentes
                <button @click="selectAll(respondents)" type="button" class="btn btn-default btn-xs">Todos os Parques</button>
                <button @click="selectCurrentAuthenticatedParkAsRespondent()" type="button" class="btn btn-default btn-xs">Apenas eu</button>
              </h4>
              <p v-if="isAllRespondentsSelected">Você visualizará relatórios referentes às respostas de todos os Parques Tecnológicos cadastrados na plataforma que responderam o questionário no ano selecionado.</p>
              <p v-if="!isAllRespondentsSelected && isCurrentAuthenticatedParkSelected">Você visualizará relatórios referentes às respostas do seu questionário no ano selecionado.</p>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="report-row" v-if="(availableReports.length > 0 || respondents.length > 0)">
              <h4>
                Relatórios
                <button @click="selectAll(availableReports)" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
                <button @click="clearSelected(availableReports)" type="button" class="btn btn-default btn-xs">Limpar</button>
              </h4>
              <div v-for="report in availableReports" :key="report.id" class="checkbox">
                <label>
                  <input v-model="report.isSelected" type="checkbox"> {{ report.title }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="isRenderingReports" class="content">
        <button @click="isRenderingReports = false" type="button" class="btn btn-primary top-btn">Voltar</button>
        <div class="row text-center display-flex">
          <div v-for="report in selectedReports" :key="report.id" class="col-xs-12 col-lg-6">
            <component :is="getReportComponent(report)" :data="report.data"></component>
          </div>
        </div>
      </section>
    </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParkClient from '@/services/resource_client/park'
  import ReportClient from '@/services/resource_client/report'
  import ReportFormatter from '@/services/report_formatter'
  import Authentication from '@/services/authentication'

  import TableReport from '../../components/elements/TableReport'
  import ListReport from '../../components/elements/ListReport'
  import BarChart from '../../components/elements/charts/BarChart'
  import DoughnutChart from '../../components/elements/charts/DoughnutChart'
  import HorizontalBarChart from '../../components/elements/charts/HorizontalBarChart'

  export default {
    name: 'QuizReports',
    components: { Adminlte, TableReport, BarChart, DoughnutChart, HorizontalBarChart },
    data () {
      return {
        isRenderingReports: false,
        year: null,
        componentsPerType: {
          'table': TableReport,
          'list': ListReport,
          'bar': BarChart,
          'doughnut': DoughnutChart,
          'horizontalBar': HorizontalBarChart
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        },
        parksWithApprovedParkQuizPerYear: {},
        respondents: [],
        axes: [
          { key: 'management', description: 'Gestão', isSelected: false },
          { key: 'services', description: 'Serviços', isSelected: false },
          { key: 'infrastructure', description: 'Infraestrutura', isSelected: false },
          { key: 'team', description: 'Equipe', isSelected: false },
          { key: 'partners', description: 'Parceiros', isSelected: false },
          { key: 'indicators', description: 'Indicadores', isSelected: false },
          { key: 'evaluation', description: 'Avaliação', isSelected: false }
        ],
        reports: [
          { id: 1, title: 'Receitas próprias do parque tecnológico', uri: 'reports/park-own-revenues-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 2, title: 'Custos e despesas do parque tecnológico', uri: 'reports/park-costs-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 3, title: 'Investimentos do parque tecnológico', uri: 'reports/park-investments-in-year-compared-to-previous-years', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 4, title: 'Recursos captados para o parque tecnológico', uri: 'reports/park-investments-by-source-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 5, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico', uri: 'reports/park-resources-by-institution-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 6, title: 'Necessidades futuras para investimento do parque tecnológico', uri: 'reports/park-future-needs-for-investments-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 7, title: 'Indicadores do parque tecnológico', uri: 'reports/park-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 8, title: 'Indicadores de inovação', uri: 'reports/park-innovations-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 9, title: 'Áreas de atuação das empresas âncora', uri: 'reports/park-anchor-companies-focus-action-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 10, title: 'Como o parque tecnológico busca a sustentabilidade financeira', uri: 'reports/how-park-seeks-financial-sustainability-in-year', data: {}, axis: 'indicators', type: 'bar', isSelected: false },
          { id: 11, title: 'Indicadores de empresas âncoras', uri: 'reports/anchor-companies-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 12, title: 'Indicadores financeiros das empresas vinculadas ao parque tecnológico - Valor Total', uri: 'reports/linked-companies-financial-indicators-in-year', data: {}, axis: 'indicators', type: 'table', isSelected: false },
          { id: 13, title: 'O parque tecnológico possui planejamento estratégico', uri: 'reports/park-has-strategic-planning-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 14, title: 'O parque tecnológico realiza auditorias', uri: 'reports/park-offers-auditing-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 15, title: 'Compõem a estrutura organizacional do parque tecnológico', uri: 'reports/park-organizational-structure-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 16, title: 'Instituições que compõem o(s) conselho(s) do parque tecnológico', uri: 'reports/park-council-institutions-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 17, title: 'O parque tecnológico está associado formalmente a quais instituições', uri: 'reports/park-related-institutions-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 18, title: 'O parque tecnológico possui alguma certificação', uri: 'reports/park-has-certifications-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 19, title: 'O parque tecnológico possui interação com algum programa de incubação e/ou aceleração de empresas', uri: 'reports/incubation-acceleration-programs-interaction-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 20, title: 'O parque tecnológico possui processo de seleção de empresas e empreendimentos', uri: 'reports/park-has-selection-process-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 21, title: 'Critérios utilizados no processo de seleção de empresas', uri: 'reports/park-selection-process-criteria-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 22, title: 'Quem são os responsáveis por avaliar as empresas durante o processo de seleção', uri: 'reports/park-selection-process-responsible-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 23, title: 'Quanto tempo leva, em média, o processo de seleção de empresas', uri: 'reports/park-selection-process-duration-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 24, title: 'Itens de dificuldade financeira para o parque tecnológico', uri: 'reports/park-financial-difficulties-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 25, title: 'Políticas públicas do país que podem melhorar a atuação de empresas instaladas em parques tecnológicos', uri: 'reports/public-politics-improvements-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 26, title: 'Mudanças de políticas públicas necessárias para melhorar a atuação dos parques tecnológicos', uri: 'reports/public-politics-needed-in-year', data: {}, axis: 'management', type: 'bar', isSelected: false },
          { id: 27, title: 'Programas oferecidos pelo parque tecnológico', uri: 'reports/programs-offered-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 28, title: 'Características dos programas oferecidos pelo parque tecnológico', uri: 'reports/features-offered-programs-in-year', data: {}, axis: 'services', type: 'table', isSelected: false },
          { id: 29, title: 'Quais cursos o parque tecnológico oferece aos empresários', uri: 'reports/courses-offered-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 30, title: 'Dificuldades enfrentadas pelo parque tecnológico para o oferecimento de cursos aos empresários', uri: 'reports/courses-offering-difficulties-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 31, title: 'O parque tecnológico possui um processo sistematizado para acompanhar o desenvolvimento das empresas', uri: 'reports/park-has-process-monitor-development-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 32, title: 'Indicadores utilizados pelo parque para acompanhar o desenvolvimento de suas empresas residentes', uri: 'reports/company-development-indicators-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 33, title: 'Quais incentivos fiscais, creditícios e/ou subsídios, são oferecidos às empresas residentes', uri: 'reports/incentives-offered-resident-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 34, title: 'Motivos de desistência e/ou desligamento das empresas do parque tecnológico', uri: 'reports/companies-abandonment-reasons-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 35, title: 'Por meio de quais atividades o parque tecnológico se relaciona com as empresas residentes', uri: 'reports/activities-park-relate-companies-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 36, title: 'Quais serviços são oferecidos pelo parque tecnológico', uri: 'reports/services-offered-by-park-in-year', data: {}, axis: 'services', type: 'bar', isSelected: false },
          { id: 37, title: 'Áreas do terreno e lotes do parque tecnológico (m²)', uri: 'reports/park-land-areas-occupied-in-year', data: {}, axis: 'infrastructure', type: 'table', isSelected: false },
          { id: 38, title: 'Áreas de prédios e edificações do parque tecnológico (m²)', uri: 'reports/park-edification-areas-occupied-in-year', data: {}, axis: 'infrastructure', type: 'table', isSelected: false },
          { id: 39, title: 'Infraestrutura, recursos e equipamentos disponíveis para as empresas', uri: 'reports/resources-available-for-companies-in-year', data: {}, axis: 'infrastructure', type: 'bar', isSelected: false },
          { id: 40, title: 'Distribuição de gênero da equipe do parque', uri: 'reports/park-team-gender-distribution-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 41, title: 'Idade média da equipe do parque', uri: 'reports/park-team-average-age-in-year', data: {}, axis: 'team', type: 'list', isSelected: false },
          { id: 42, title: 'Distribuição de escolaridade da equipe do parque', uri: 'reports/park-team-schooling-distribution-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 43, title: 'Dificuldades enfrentadas pelo parque tecnológico na contratação de mão de obra qualificada', uri: 'reports/park-hiring-difficulties-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 44, title: 'Problemas enfrentados pelo parque tecnológico com relação à sua equipe interna', uri: 'reports/park-team-issues-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 45, title: 'Em quais áreas o parque tecnológico contrata seus profissionais', uri: 'reports/park-hiring-areas-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 46, title: 'Percentual de funcionários por nível de escolaridade', uri: 'reports/team-education-in-year', data: {}, axis: 'team', type: 'doughnut', isSelected: false },
          { id: 47, title: 'Área de formação dos membros da equipe', uri: 'reports/team-formation-area-in-year', data: {}, axis: 'team', type: 'horizontalBar', isSelected: false },
          { id: 48, title: 'Quantidade de membros por tipo de vínculo', uri: 'reports/team-bond-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 49, title: 'Quantidade de membros por função', uri: 'reports/team-function-in-year', data: {}, axis: 'team', type: 'bar', isSelected: false },
          { id: 50, title: 'Atores com os quais o parque tecnológico possui parceria', uri: 'reports/park-has-partnership-with-actors-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false },
          { id: 51, title: 'Com quais órgãos e/ou instituições o parque tecnológico possui parcerias internacionais formalizadas', uri: 'reports/park-formalized-international-partnerships-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false },
          { id: 52, title: 'Parcerias que são fundamentais para o fortalecimento do parque tecnológico', uri: 'reports/park-key-partnerships-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false },
          { id: 53, title: 'Quais atividades o parque tecnológico realiza para promoção de networking', uri: 'reports/park-activities-promote-networking-in-year', data: {}, axis: 'partners', type: 'bar', isSelected: false },
          { id: 54, title: 'Condições necessárias para o sucesso dos parques tecnológicos', uri: 'reports/park-success-necessary-conditions-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false },
          { id: 55, title: 'Itens associados à proposta de valor do parque tecnológico para as empresas residentes', uri: 'reports/park-value-offer-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false },
          { id: 56, title: 'Recursos que são oferecidos pelo parque tecnológico para atender às demandas tecnológicas das empresas residentes', uri: 'reports/park-resources-offered-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false },
          { id: 57, title: 'Impactos gerados pelo parque tecnológico para a comunidade local', uri: 'reports/park-impacts-generated-in-year', data: {}, axis: 'evaluation', type: 'bar', isSelected: false }
        ]
      }
    },
    mounted () {
      this.getParksWithApprovedParkQuizPerYear()
    },
    methods: {
      getParksWithApprovedParkQuizPerYear () {
        ParkClient.withApprovedParkQuizPerYear()
          .then(response => {
            this.parksWithApprovedParkQuizPerYear = response.data
          })
      },
      selectAll (list) {
        list.forEach(function (el) {
          el.isSelected = true
        })
      },
      clearSelected (list) {
        list.forEach(function (el) {
          el.isSelected = false
        })
      },
      selectCurrentAuthenticatedParkAsRespondent () {
        this.clearSelected(this.respondents)
        if (this.currentAuthenticatedParkIndexAtRespondentsList < 0) {
          return
        }
        this.respondents[this.currentAuthenticatedParkIndexAtRespondentsList].isSelected = true
      },
      renderReports () {
        if (this.selectedRespondents.length === 0) return
        this.isRenderingReports = true
        this.selectedReports.forEach(r => this.renderReport(r.id))
      },
      renderReport (id) {
        let report = this.reports.find(r => r.id === id)
        let respondentsIds = this.selectedRespondents.map(el => el.id)
        ReportClient.getInYearForRespondents(report.uri, this.year, respondentsIds)
          .then(response => {
            switch (report.type) {
              case 'bar':
                report.data = ReportFormatter.chart(response.data, report.title)
                break
              case 'doughnut':
                report.data = ReportFormatter.doughnutChart(response.data, report.title)
                break
              case 'horizontalBar':
                report.data = ReportFormatter.horizontalBarChart(response.data, report.title)
                break
              default:
                report.data = ReportFormatter.textual(response.data, report.title)
            }
            report.isSelected = true
          })
      },
      getReportComponent (r) {
        return this.componentsPerType[r.type]
      }
    },
    computed: {
      getAvailableYears () {
        let availableYears = Object.keys(this.parksWithApprovedParkQuizPerYear)
        availableYears.sort().reverse()
        return availableYears
      },
      availableReports () {
        let selectedAxes = this.axes.filter(a => a.isSelected).map(a => a.key)
        return this.reports.filter(r => selectedAxes.includes(r.axis))
      },
      selectedReports () {
        return this.availableReports.filter(r => r.isSelected)
      },
      selectedRespondents () {
        return this.respondents.filter(r => r.isSelected)
      },
      userHasAdminRole () {
        return Authentication.userHasAdminRole()
      },
      userHasResearcherRole () {
        return Authentication.userHasResearcherRole()
      },
      userHasParkRole () {
        return Authentication.userHasParkRole()
      },
      userHasPartnerRole () {
        return Authentication.userHasPartnerRole()
      },
      userCanSelectRespondents () {
        return this.userHasAdminRole || this.userHasPartnerRole || this.userHasResearcherRole
      },
      currentAuthenticatedParkIndexAtRespondentsList () {
        return this.respondents.findIndex(r => r.id === Authentication.getParkId())
      },
      isAllRespondentsSelected () {
        return this.respondents.every(r => r.isSelected)
      },
      isCurrentAuthenticatedParkSelected () {
        if (this.currentAuthenticatedParkIndexAtRespondentsList < 0) {
          return false
        }
        return this.respondents[this.currentAuthenticatedParkIndexAtRespondentsList].isSelected
      }
    },
    watch: {
      year: function (newYear, oldYear) {
        this.respondents = []
        if (!newYear) {
          return
        }
        const parksWithApprovedParkQuizAtSelectedYear = this.parksWithApprovedParkQuizPerYear[newYear] || []
        parksWithApprovedParkQuizAtSelectedYear.forEach(park => {
          this.respondents.push({'id': park.id, 'name': park.name, 'isSelected': false})
        })
      }
    }
  }
</script>

<style scoped>
  .main-row {
    color: white;
  }
  .year-label {
    display: table-cell;
    vertical-align: middle;
    height: 34px;
  }
  .center-inside-col {
    display: table;
    margin: 0 auto;
    font-size: small;
  }
  .report-row {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 5px;
    margin-bottom: 15px;
  }
  .display-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .display-flex > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }
  .top-btn {
    margin-bottom: 10px;
  }
  .highlight {
    font-weight: bold;
  }
  .axes-container {
    display: flex;
  }
  .axes-container span {
    cursor: pointer;
    padding-bottom: 15px;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// QuizReports.vue?f10270bc